import { render, staticRenderFns } from "./LeadAlerts.vue?vue&type=template&id=1a149eea&scoped=true&"
import script from "./LeadAlerts.vue?vue&type=script&lang=js&"
export * from "./LeadAlerts.vue?vue&type=script&lang=js&"
import style0 from "./LeadAlerts.vue?vue&type=style&index=0&id=1a149eea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a149eea",
  null
  
)

export default component.exports